import React from 'react'

import { ZariContext } from '_zari/context'
import { Portlet, Button, Col, Row } from '_zari/core'

import { DownloadAxiosFile } from 'utils'

import * as AsientosContablesServices from 'services/asientosContables.service'

const PleAnualPage = () => {
  const __zariContext = React.useContext(ZariContext)

  const clickDescargarExcel = React.useCallback(() => {
    __zariContext.loader.open('Descargando PLE anual')
    AsientosContablesServices.descargarBalancePleAnual()
      .then(({ data, headers }) => {
        DownloadAxiosFile.downloadAsBlob(data, headers)
      })
      .catch(({ data: { error } }) => {
        __zariContext.snack('error', error)
      })
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [__zariContext])

  return (
    <Portlet>
      <Portlet.Header title='Balance Sunat - PLE Anual' />
      <Portlet.Body>
        <Row>
          <Col md={12}>
            <Button tiny outline onClick={clickDescargarExcel}>
              Descargar Excel Anual
            </Button>
          </Col>
        </Row>
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(PleAnualPage)
